import { useEffect } from "react";

const PROPERTY_ID = process.env.REACT_APP_TAWK_PROPERTY_ID;
const WIDGET_ID = process.env.REACT_APP_TAWK_WIDGET_ID;

export const LiveChatProvider = () => {
  useEffect(() => {
    if (!PROPERTY_ID || !WIDGET_ID) return;
    if ((window as any).Tawk_API) return;

    (window as any).Tawk_API = {};
    (window as any).Tawk_LoadStart = new Date();

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://embed.tawk.to/${PROPERTY_ID}/${WIDGET_ID}`;
    script.charset = "UTF-8";
    script.setAttribute("crossorigin", "*");

    document.body.appendChild(script);
  }, []);

  return null;
};
